import StatusLabel from 'Components/Atoms/Label/StatusLabel/StatusLabel';
import Text from 'Components/Atoms/Text/Text';
import TableCell from 'Components/Molecules/TableCell/TableCell';
import TableRow from 'Components/Molecules/TableRow/TableRow';
import Field from 'Components/Organisms/Field/Field';
import { connect } from 'react-redux';
import { InternalDatasets } from 'Services/helpers';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import { getFieldsById } from 'Store/Settings/Fields/Selectors';
import { selectRecordsByIdByEntityName, selectValuesByIdByEntityName } from 'Store/Shared/Store/Values/Selector';

const EntityOverviewTableRow = ({
    entity,
    record_id,
    record,
    values,
    fields,
    fieldById
}: EntityOverviewTableRowProps) => {
    return <TableRow href={EntityHelper.getEntityRoute(entity?.name, record_id)}>
        <TableCell
            position='fixed'
            size='medium'
        >
            <StatusLabel
                status={record?.status?.status}
                substatus={record?.status?.substatus}
            />
        </TableCell>
        <TableCell
            position='fixed'
            size='large'
            offsetLeft={200}
            primary
        >
            <Text>
                { record?.display_name }
            </Text>
        </TableCell>
        {
            fields?.map(fieldId => {
                const field = fieldById?.[fieldId];

                if (fieldId === 'owners') {
                    return <TableCell
                        id={fieldId}
                        key={fieldId}
                    >
                        <Field
                            value={record.owners}
                            type={FieldType.Multi_Selector}
                            properties={{
                                ...field?.default,
                                dataset: [InternalDatasets.USERS],
                                alignLeft: true
                            }}
                        />
                    </TableCell>;
                }

                if (fieldId === 'updated_at' || fieldId === 'created_at') {
                    return <TableCell
                        id={fieldId}
                        key={fieldId}
                    >
                        <Field
                            value={record?.[fieldId]}
                            type={FieldType.Date}
                            properties={{
                                ...field?.default,
                                alignLeft: true
                            }}
                        />
                    </TableCell>;
                }

                if (field.type === FieldType.Combination) {
                    return <>
                        {
                            field
                            ?.default
                            ?.fields
                            ?.map(combinationFieldId => {
                                const combinationField = fieldById?.[combinationFieldId];
                                let value = values
                                    ?.[field.id]
                                    ?.value
                                    ?.reduce(
                                        (acc, curr) =>
                                            acc = [
                                                ...acc,
                                                ...(curr?.[combinationFieldId] ?? [])
                                            ]
                                        ,
                                        []
                                    );

                                // @ts-ignore
                                value = [...new Set(value)];

                                return <TableCell
                                    id={`${fieldId}+${combinationFieldId}`}
                                    key={`${fieldId}+${combinationFieldId}`}
                                >
                                    <Field
                                        value={value}
                                        type={combinationField?.type}
                                        properties={{
                                            ...combinationField?.default,
                                            alignLeft: true
                                        }}
                                    />
                                </TableCell>
                            })
                        }
                    </>
                }

                return <TableCell
                    id={fieldId}
                    key={fieldId}
                >
                    <Field
                        value={values?.[fieldId]?.value}
                        type={field?.type}
                        properties={{
                            ...field?.default,
                            alignLeft: true
                        }}
                    />
                </TableCell>
            })
        }
    </TableRow>;
}

interface Props {
    entity: any
    record_id: any
    fields: any
}

const mapState = (state: StoreState, props: Props) => ({
    fieldById: getFieldsById(state),

    record: selectRecordsByIdByEntityName(state, props.entity?.name, props?.record_id),
    values: selectValuesByIdByEntityName(state, props.entity?.name, props?.record_id)
});

const mapDispatch = {

};

type EntityOverviewTableRowProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntityOverviewTableRow);